import { useEffect, useState, useRef } from "react";

const visions = [
  { id: "covenant-vision", label: "The Vision of the Saints, Beasts, and Blood" },
  { id: "seraphim-vision", label: "Vision of the SERAPHIM and the CHERUBIMS" },
  { id: "dark-beast-vision", label: "The Vision About the Dark Beast..." },
  { id: "lion-judah-vision", label: "The Vision About the Lion of Judah" },
  { id: "battle-saints-vision", label: "The VISION OF THE BATTLE..." },
  { id: "pornography-vision", label: "THE VISION ABOUT PORNOGRAPHY" },
  { id: "gathering-army-vision", label: "The Vision of the Gathering of the Heavenly Army" },
  { id: "invasion-children-vision", label: "The Vision of the Invasion of the Children..." },
  { id: "great-banquet-vision", label: "THE VISION OF THE GREAT BANQUET" },
  { id: "demonic-agenda-vision", label: "The Vision about the Demonic Agenda..." },
  { id: "mountain-of-transfiguration-vision", label: "The Vision of the Mountain of Transfiguration" },
  { id: "lord-jesus-message-vision", label: "THE VISION OF THE LORD JESUS..." },
  { id: "lord-jesus-grieved-vision", label: "The Vision of the Lord Jesus Grieved" },
  { id: "vision-of-the-palm-branches", label: "THE VISION OF THE PALM BRANCHES" },
  { id: "evil-birds-cover-light-heaven", label: "The Vision of the Evil Birds..." },
  { id: "encounter-moses-samuel-book-generations", label: "My Encounter with Moses and Samuel..." },
  { id: "my-visit-to-heaven-full-version", label: "My Visit to Heaven (Full Version)" },
  { id: "the-vision-of-the-heavenly-market", label: "The Vision of the Heavenly Market" },
  { id: "three-evil-beings-prophecy", label: "Prophecy About the 3 Evil Beings..." },
  { id: "sheep-with-eagle-wings", label: "The Vision of the Sheep That Mounted up with Wings" },
  { id: "fruitful-tree-vision", label: "The Vision of the Great Fruitful Tree" },
  { id: "sheep-evil-birds-wild-cows-lion", label: "The Vision of the Sheep, Evil Birds..." },
  { id: "cloud-of-witnesses", label: "The Vision of The Cloud of Witnesses" },
  { id: "visions-2024-point-1", label: "For Cameroon 2024 shall be the Year..." },
  { id: "visions-2024-point-2", label: "The fire in the NW and SW Regions" },
  { id: "visions-2024-point-3", label: "I saw 3 rams fighting..." },
  { id: "visions-2024-point-4", label: "The agricultural sector will be the strength..." },
  { id: "visions-2024-point-5", label: "The Lord has declared unto the Church..." },
  { id: "visions-2-church", label: "IN THE VISIONS OF GOD 2 - Prophetic Word" },
  { id: "visions-3-world", label: "IN THE VISIONS OF GOD 3 - For the World" },
];

function VisionDropdownNav() {
  const [showNav, setShowNav] = useState(true);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const hideTimeoutRef = useRef(null);
  const dropdownRef = useRef(null);

  // Hide/Show nav on scroll
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        // scrolling down
        if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
        hideTimeoutRef.current = setTimeout(() => {
          setShowNav(false);
        }, 1500);
      } else {
        // scrolling up
        if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
        setShowNav(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
    };
  }, [lastScrollY]);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Scroll to section
  const scrollTo = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setDropdownOpen(false);
    }
  };

  return (
    <div
      className={`fixed border border-border rounded right-[1px] w-[100px] z-10 transition-all duration-300 top-[1px] md:top-[54px] ${showNav ? "translate-y-0 opacity-100" : "-translate-y-20 opacity-0"
        }`}
    >
      <div className="relative" ref={dropdownRef}>
        <button
          onClick={() => setDropdownOpen((p) => !p)}
          className="w-full h-[37px] bg-accent text-text text-[12px] font-bold rounded cursor-pointer shadow-lg outline-none"
        >
          Select a Vision
        </button>

        <div className="relative mr-0">
          {dropdownOpen && (
            <ul
              className="
        absolute right-0 text-text top-full mt-2
        w-[300px]
        max-h-[400px]
        overflow-y-auto
        bg-card
        border
        rounded
        shadow-xl
        z-[9999]
      "
            >
              {visions.map((v) => (
                <li
                  key={v.id}
                  onClick={() => scrollTo(v.id)}
                  className="px-3 py-2 text-sm hover:bg-accent cursor-pointer"
                >
                  {v.label}
                </li>
              ))}
            </ul>
          )}
        </div>

      </div>
    </div>
  );
}

export default VisionDropdownNav;
